import { useWorkspace } from '@/features/workspaces/hooks';
import { useCompanyValues } from '@/providers';
import { useGetConnectorFlowsQuery, useGetWorkspaceConnectorsQuery } from '@/services/endpoints/workspace-connectors';
import { ConnectorFlowDTO, CustomConnectorDto } from '@/models/connectors';

export const getConnectorsWithAvailableFlows = (connectors: CustomConnectorDto[], connectorFlows: ConnectorFlowDTO[]): CustomConnectorDto[] => {
  const connectorIdsWithFlows = new Set(connectorFlows.filter((flow) => flow.active !== false && flow.enabled !== false).map((flow) => flow.connectorId));

  return connectors.filter((connector) => connectorIdsWithFlows.has(connector.id));
};

export const useGetAvailableDestinationConnectors = () => {
  const { id: workspaceId } = useWorkspace();
  const { currentLanguage: lang } = useCompanyValues();

  const { data: connectors, isLoading: connectorsLoading } = useGetWorkspaceConnectorsQuery({ workspaceId, lang });
  const { data: flows, isLoading: flowsLoading } = useGetConnectorFlowsQuery({ workspaceId, lang });

  const filteredConnectors = getConnectorsWithAvailableFlows(connectors || [], flows || []);

  return { connectors: filteredConnectors, flows, connectorsLoading, flowsLoading, isLoading: connectorsLoading || flowsLoading };
};
